import { createSlice } from "@reduxjs/toolkit";

export const GlobalDetailsSlice = createSlice({
  name: "globalData",
  initialState: {
    data: null,
    lang: 'en',
  },
  reducers: {
    addData: (state, action) => {
      state.data = action.payload;
    },

    changeLang: (state, action) => {
      state.lang = action.payload;
    },
  },
});

export const { addData, changeLang } = GlobalDetailsSlice.actions;
export default GlobalDetailsSlice.reducer;
